<template>
  <div class="land-list-wrapper" ref="listWrapper" v-loading="loading">
    <div class="land-list">
      <land-card
        v-for="item in showLandList"
        :key="item.landId"
        :info="item"
        @click.native="handleClickLand(item)"
      ></land-card>
    </div>
    <div class="no-land-data" v-if="!loading && showLandList.length == 0">
      <img src="@/assets/images/insure/no-land-data.png" alt="" />
      <p>没有找到种植了可投保作物的地块</p>
    </div>
  </div>
</template>

<script>
import LandCard from "../components/LandCard";
import initBScroll from "@/utils/bScroll";
import { mapGetters, mapState } from "vuex";
export default {
  name: "ListMode",
  components: { LandCard },
  data() {
    return {
      scroll: null,
    };
  },
  computed: {
    ...mapGetters({
      showLandList: "insure/showLandList",
    }),
    ...mapState("insure", {
      loading: "landLoading",
      currentMode: "showLandMode",
    }),
  },
  watch: {
    currentMode(val) {
      if (val == "ListMode") {
        this.$nextTick(() => {
          console.log("刷新");
          this.refreshScroll();
        });
      }
    },
  },
  mounted() {
    this.scroll = initBScroll(this.$refs.listWrapper);
  },

  methods: {
    // 点击地块
    handleClickLand(item) {
      if (!item.insureFlag) {
        return;
      }
      console.log(item);
      this.$store.commit("insure/changeSelectStatus", item.landId);
    },
    refreshScroll() {
      this.scroll && this.scroll.refresh();
    },
  },
};
</script>

<style lang="scss" scoped>
.land-list-wrapper {
  position: relative;
  //  height: calc(100% - 110px);
  height: 100%;
  overflow: hidden;
  padding: 0 15px;
  .land-list {
    display: flex;
    flex-wrap: wrap;
    padding: 15px 15px 0px 15px;
  }
  ::v-deep .bscroll-vertical-scrollbar {
    z-index: 20 !important;
    .bscroll-indicator {
      background: #dcdfe6 !important;
    }
  }

  .no-land-data {
    padding-top: 228px;
    img {
      display: block;
      width: 151px;
      height: 115px;
      margin: 0 auto;
    }
    p {
      font-size: 16px;
      line-height: 22px;
      color: #333333;
      text-align: center;
      margin-top: 24px;
    }
  }
}
</style>
